/**
 * Shopify affiliate tracking helper
 *
 * - Stores ?ref= and ?campaign= from the URL as cart attributes (affiliate_ref, affiliate_campaign).
 * - Registers a visit with the affiliate hub and stores visit_id in cookie + cart attribute
 *   so Flow can link the referral to the visit.
 *
 * Configure VISIT_ENDPOINT below to your hub's shopify-visit endpoint URL.
 * 
 * OSTWERK>>
 */
(function () {
  'use strict';

  // Change this to your hub's shopify-visit endpoint (mu-plugin on affiliate hub).
  var VISIT_ENDPOINT = 'https://affiliate.culinarius.at/wp-json/abb/v1/shopify-visit';
  var COOKIE_VISIT_ID = 'affiliate_visit_id';
  var COOKIE_DAYS = 30;
  var MAX_LENGTH = 64;
  var PARAM_REF = 'ref';
  var PARAM_CAMPAIGN = 'campaign';

  function sanitizeParam(value) {
    if (!value) return '';
    var trimmed = String(value).trim();
    if (trimmed.length === 0 || trimmed.length > MAX_LENGTH) return '';
    if (!/^[a-zA-Z0-9_-]+$/.test(trimmed)) return '';
    return trimmed;
  }

  function getParam(name) {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function getVisitIdCookie() {
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + COOKIE_VISIT_ID + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setVisitIdCookie(visitId) {
    var d = new Date();
    d.setTime(d.getTime() + COOKIE_DAYS * 24 * 60 * 60 * 1000);
    document.cookie = COOKIE_VISIT_ID + '=' + encodeURIComponent(String(visitId)) + ';path=/;expires=' + d.toUTCString() + ';SameSite=Lax' + (location.protocol === 'https:' ? ';Secure' : '');
  }

  var ref = sanitizeParam(getParam(PARAM_REF));
  if (!ref) {
    if (window && window.console && typeof window.console.debug === 'function') {
      window.console.debug('[ABB] No valid ref param found in URL');
    }
    return;
  }

  var campaign = sanitizeParam(getParam(PARAM_CAMPAIGN));
  if (window && window.console && typeof window.console.debug === 'function') {
    window.console.debug('[ABB] Captured params', { ref: ref, campaign: campaign });
  }

  fetch('/cart.js', {
    method: 'GET',
    credentials: 'same-origin'
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    })
    .then(function (cart) {
      var attributes = (cart && cart.attributes) ? cart.attributes : {};
      var currentRef = attributes.affiliate_ref || '';
      var currentCampaign = attributes.affiliate_campaign || '';
      var currentVisitId = attributes.affiliate_visit_id || getVisitIdCookie();

      if (currentRef === ref && (!campaign || currentCampaign === campaign) && currentVisitId) {
        if (window && window.console && typeof window.console.debug === 'function') {
          window.console.debug('[ABB] Cart attributes and visit already set', {
            affiliate_ref: currentRef,
            affiliate_campaign: currentCampaign,
            affiliate_visit_id: currentVisitId
          });
        }
        return;
      }

      var newAttributes = {};
      for (var key in attributes) {
        if (Object.prototype.hasOwnProperty.call(attributes, key)) {
          newAttributes[key] = attributes[key];
        }
      }
      newAttributes.affiliate_ref = ref;
      if (campaign) {
        newAttributes.affiliate_campaign = campaign;
      } else if (currentCampaign) {
        newAttributes.affiliate_campaign = currentCampaign;
      }

      // If we don't have a visit_id yet, register a visit with the hub first.
      function doCartUpdate(visitId) {
        if (visitId) {
          newAttributes.affiliate_visit_id = String(visitId);
          setVisitIdCookie(visitId);
        }
        if (window && window.console && typeof window.console.debug === 'function') {
          window.console.debug('[ABB] Updating cart attributes', newAttributes);
        }
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: newAttributes })
        });
      }

      if (currentVisitId) {
        newAttributes.affiliate_visit_id = String(currentVisitId);
        return doCartUpdate(null);
      }

      // Always update cart with ref and campaign first so they persist even if visit is blocked (e.g. ad blocker).
      var cartUpdatePromise = doCartUpdate(null);

      // Then try to create visit on hub; if it succeeds, add visit_id to cart.
      var visitPayload = {
        affiliate_ref: ref,
        campaign: campaign,
        landing_url: window.location.href || '',
        referrer: document.referrer || ''
      };
      if (window && window.console && typeof window.console.debug === 'function') {
        window.console.debug('[ABB] Sending visit to hub', visitPayload);
      }
      fetch(VISIT_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(visitPayload)
      })
        .then(function (visitResponse) {
          if (visitResponse.ok && visitResponse.status === 201) {
            return visitResponse.json().then(function (data) {
              var visitId = data.visit_id || null;
              if (visitId && window && window.console && typeof window.console.debug === 'function') {
                window.console.debug('[ABB] Visit created', { visit_id: visitId });
              }
              if (visitId) {
                return doCartUpdate(visitId);
              }
            });
          }
          if (window && window.console && typeof window.console.debug === 'function') {
            window.console.debug('[ABB] Visit request failed', visitResponse.status);
          }
        })
        .catch(function () {
          if (window && window.console && typeof window.console.debug === 'function') {
            window.console.debug('[ABB] Visit request blocked or failed; ref/campaign already saved to cart');
          }
        });

      return cartUpdatePromise;
    })
    .then(function (updateResponse) {
      if (!updateResponse) return;
      if (window && window.console && typeof window.console.debug === 'function') {
        window.console.debug('[ABB] Cart attributes update response', {
          ok: updateResponse.ok,
          status: updateResponse.status
        });
      }
    })
    .catch(function (error) {
      if (window && window.console && typeof window.console.debug === 'function') {
        window.console.debug('[ABB] Tracking error', error);
      }
    });
})();
